// Pure string builders for apexcharts custom tooltips (the apexcharts tooltip DOM contract lives here).
// Kept free of any runtime import so modules covered by jest unit tests (e.g. networkOutagePresentation.ts)
// can depend on it directly.
export const tooltipTitleBlock = (title: string): string =>
  ['<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">', title, '</div>'].join('')

export const tooltipRow = (label: string, value: string): string =>
  [
    '<div class="apexcharts-tooltip-goals-group">',
    '<span class="apexcharts-tooltip-text-goals-label">',
    `${label}: `,
    '</span>',
    '<span class="apexcharts-tooltip-text-goals-value">',
    value,
    '</span>',
    '</div>'
  ].join('')
